/* eslint-disable no-extra-semi */
import { HttpClient, HttpErrorResponse, HttpEvent, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { Router } from '@angular/router'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { BaseSiteService, GlobalMessageType, OccConfig, RoutingService } from '@spartacus/core'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { Observable, of, throwError } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { DataConfirmModal } from '../../features/shared/confirm-modal/confirm-modal.component'
import { SharedValue } from '../../models/enum/shared.enum'
import { ICustomUser } from '../../models/interface/user.interface'
import { AppConfigurationService } from '../app-configuration.service'
import { CustomGlobalMessageService } from './custom-global-message/custom-global-message.service'

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public baseSiteId: string
  public user: ICustomUser
  public sapCreditBlocked: boolean
  public creditBlockedSimulation: boolean
  public disableSimulate: boolean
  public showSimulationLoader: boolean
  public urlAfterLogin: string
  private queryParams: any
  public userName: any
  dialogs: any

  constructor(
    private baseSiteService: BaseSiteService,
    private userAccountFacade: UserAccountFacade,
    private globalMessageService: CustomGlobalMessageService,
    private modalService: NgbModal,
    private bottomSheet: MatBottomSheet,
    private router: Router,
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private routingService: RoutingService,
    private occConfig: OccConfig
  ) {
    baseSiteService.getActive().subscribe((baseSiteId) => (this.baseSiteId = baseSiteId))
  }

  public getUser(): Observable<ICustomUser> {
    return this.userAccountFacade
      .get()
      .pipe(tap((user: ICustomUser) => (this.sapCreditBlocked = user?.sapCreditBlocked)))
  }

  public get isUserCreditHold(): boolean {
    return this.sapCreditBlocked || this.creditBlockedSimulation
  }

  public showCreditHoldMessage(): void {
    this.globalMessageService.add({ key: 'creditHold.message' }, GlobalMessageType.MSG_TYPE_ERROR)
  }

  public showTotalAmountLessMessage(amount: any): void {
    this.globalMessageService.add(
      { key: 'totalAmount.message', params: { amount: amount } },
      GlobalMessageType.MSG_TYPE_ERROR
    )
  }

  public showConfirmModal(component: any, data: DataConfirmModal): Promise<boolean> {
    return new Promise((resolve) => {
      const modalRef = this.modalService.open(component, { centered: true })
      modalRef.componentInstance.data = data
      modalRef.result.then(
        () => resolve(true),
        () => resolve(false)
      )
    })
  }

  public openBottomSheet(sheet: any): void {
    this.bottomSheet.open(sheet, { panelClass: 'custom-bottom-sheet-error' })
  }

  // TODO key will get value from Params so we'll just change the function definition
  public getUrlParam(key: string): Observable<string> {
    const urlParams = this.router.url.split('/')
    const params = urlParams[urlParams.length - 1]

    const ids = params.split('?')
    return of(ids[0])
  }

  public handleError(err: HttpErrorResponse): any {
    let errorMsg: string
    let errorType: string
    if (err.error instanceof ErrorEvent) {
      errorMsg = 'An error occurred: ' + err.error.message
    } else {
      if (err.error?.errors?.length) {
        ;({ message: errorMsg, type: errorType } = err.error.errors[0])
      } else {
        errorMsg = SharedValue.errorTryAgain
      }
    }
    return throwError({ message: errorMsg, type: errorType })
  }

  public uploadMedia(file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData()
    const baseUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseUrl}/users/current/uploadMedia`
    formData.append('files', file)
    const req = new HttpRequest('POST', `${url}`, formData, {
      reportProgress: true,
      responseType: 'json'
    })
    return this.http.request(req)
  }

  public getQueryParams(): Observable<any> {
    return this.routingService.getRouterState().pipe(
      map((routerState) => {
        return routerState.state.queryParams
      })
    )
  }

  public getQueryParamsLocal(key: string): any {
    return this.queryParams && this.queryParams[key]
  }

  public setQueryParamsLocal(obj: any): void {
    if (!this.queryParams) {
      this.queryParams = {}
    }
    this.queryParams = { ...this.queryParams, ...obj }
  }

  public getMediaUrl(url: string): string {
    const baseUrl = this.occConfig.backend.occ.baseUrl
    return baseUrl + url
  }

  private getFileName(name: string): string {
    name = name?.trim()
    if (!name) {
      name = 'File'
    }
    return name
  }

  public userNameset(value: any) {
    this.userName = value
  }

  public dialogData(value: any) {
    return (this.dialogs = value)
  }
}
